"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyDrawer = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyList_1 = __importDefault(require("../SskyList"));

const StyledDrawerHeader = (0, material_1.styled)("div")(({
  theme
}) => Object.assign(Object.assign({
  display: "flex",
  alignItems: "center",
  padding: "0 8px"
}, theme.mixins.toolbar), {
  color: "#999999",
  backgroundColor: "#ffffff",
  borderBottom: "1px solid #DDDDDD"
}));
const StyledSskyList = (0, material_1.styled)(SskyList_1.default)({
  [`& .${material_1.listItemClasses.root}`]: {
    cursor: "pointer",
    textAlign: "start",
    height: "auto",
    "&:hover": {
      backgroundColor: "initial"
    }
  },
  [`& .${material_1.listItemClasses.container}`]: {
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)"
    }
  },
  [`& .${material_1.listItemClasses.selected}`]: {
    backgroundColor: "rgba(255, 255, 255, 0.1)!important"
  },
  [`& .${material_1.listItemTextClasses.root}`]: {
    color: "#ffffff"
  },
  [`& .${material_1.listItemTextClasses.primary}`]: {
    color: "#ffffff"
  }
});
const StyledDrawer = (0, material_1.styled)(material_1.Drawer)({
  [`& .${material_1.drawerClasses.paper}`]: {
    position: "fixed",
    top: 0,
    width: 250,
    backgroundColor: "#333333",
    color: "#ffffff"
  }
});

const SskyDrawer = props => {
  var _a;

  const renderHeader = () => {
    if (props.header) {
      return react_1.default.createElement(StyledDrawerHeader, null, props.header);
    }

    return null;
  };

  const renderItems = () => {
    var _a, _b, _c, _d;

    return react_1.default.createElement(StyledSskyList, {
      items: props.items,
      addDividers: false,
      listItemClassName: props.listItemClassName,
      classes: {
        listItem: (_a = props.classes) === null || _a === void 0 ? void 0 : _a.listItem,
        selectedListItem: (_b = props.classes) === null || _b === void 0 ? void 0 : _b.selectedListItem,
        listItemText: (_c = props.classes) === null || _c === void 0 ? void 0 : _c.listItemText,
        listItemContainer: (_d = props.classes) === null || _d === void 0 ? void 0 : _d.listItemContainer
      },
      className: props.listClassName
    });
  };

  return react_1.default.createElement(StyledDrawer, {
    anchor: props.anchor,
    classes: {
      paper: (_a = props.classes) === null || _a === void 0 ? void 0 : _a.paper
    },
    className: props.className,
    onClose: props.onClose,
    open: props.open,
    variant: props.variant,
    "data-testid": props.dataTestId
  }, renderHeader(), renderItems());
};

exports.SskyDrawer = SskyDrawer;
SskyDrawer.defaultProps = {
  header: null
};
exports.default = react_1.default.memo(SskyDrawer);